export class CustomerProfileMdl
{
  public   InsuredName: string;
  public  MobileNo: string;
  public EmailID: string;
  public Language: string;
  public IqamaNo: string;
  public Country: string;
  public Address: string;
  public  IBAN: string;
  public RegNo:string;
  public EditEmailAddress:boolean;
  public EditIBANNo:boolean;
  public EditMobileNo:boolean;
  public Password:string;
  public EditPassword:boolean;
  public BuildingNo :string;
  public Street :string;
  public District :string;
  public City :string;
  public PostalCode :string;
  public AdditionalNo :string;
  public AccountName:string;
  
}
export class ProfileReqMdl
{
  public RegNo: string;
  public  MobileNo: string;
  public EmailID: string;
  public Language: string;
  public IqamaNo: string;
  public Country: string;
  public Address: string;
  public  IBAN: string;


  public EditEmailAddress:boolean;
  public EditIBANNo:boolean;
  public EditMobileNo:boolean;
  public EditLang:boolean;

  public  Password:string;
  public  NewPassword:string;
  public  ConfirmPassword:string;
  public EditPassword:boolean;
  public AccountName:string;

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/CustomerProfileMdl.ts